import { FC, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { useClassNamesWithStyle } from '@edikk-edikk/country-frontend';
import { CardLocationCityChooser, CardLocationCityChooserHolderButton } from '#home/components/card-location';
import { CityForSelectType } from '#home/types';
import cardLocationCityChooserHolderCss from '../assets/card-location-city-chooser-holder.module.scss';

const CardLocationCityChooserHolder: FC = () => {
  const [selectedCity, setSelectedCity] = useState<CityForSelectType|null>(null);
  const classNamesWithStyle = useClassNamesWithStyle();

  return (
    <div
      className={classNamesWithStyle(
        cardLocationCityChooserHolderCss.cardLocationCityChooserHolder,
        cardLocationCityChooserHolderCss.cardLocationCityChooserHolder_styleDefault,
        cardLocationCityChooserHolderCss.cardLocationCityChooserHolder_styleRed,
      )}
    >
      <div className={cardLocationCityChooserHolderCss.cardLocationCityChooserHolder__text}>
        <FormattedMessage defaultMessage="type" />
      </div>
      <CardLocationCityChooser selectedCity={selectedCity} setSelectedCity={setSelectedCity} />
      <CardLocationCityChooserHolderButton selectedCity={selectedCity} />
    </div>
  );
};

export { CardLocationCityChooserHolder };
